// action
import {
    DELETE_PAGE_CONTENT,
    DELETE_PAGE_CONTENT_FAIL,
    DELETE_PAGE_CONTENT_SUCCESS,
    DELETE_PAGE_CONTENT_RESET
} from '../action/deletePageContentAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case DELETE_PAGE_CONTENT:
            return {
                ...state,
                apiState: "loading"
            }
        case DELETE_PAGE_CONTENT_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case DELETE_PAGE_CONTENT_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case DELETE_PAGE_CONTENT_RESET:
            return initialState
        default:
            return state
    }
}